<!-- Feature header template -->
<ng-template #featureHeader let-feature="feature" let-type="type">
  <div class="d-flex flex-row">
    <div class="p-1 flex-grow-1"><em>{{serializeFeatureName(feature)}}</em></div>
    <!-- TODO: Remove function call from template -->
    <a class="p-1" *ngIf="isFeatureRemovable(feature) && type" (click)="removeFeature(feature)" data-toggle="tooltip"
      [title]="'QUERY.featurePopup.' + type | translateHs">
      <i class="icon-remove-circle" style="color: rgb(228, 99, 99)"></i>
    </a>
  </div>
</ng-template>

<!-- Feature attribute row template -->
<ng-template #featureAttribute let-attributes="attributes">
  <div *ngFor="let attribute of attributes" class="d-flex flex-row">
    <ng-container *ngIf="attribute.key">
      <div class="p-1 flex-grow-1">
        {{translateString(
        'FEATURE_TABLE',
        attribute.key
        )}} 
      </div>
    </ng-container>
    <ng-container *ngIf="attribute.displayFunction">
      <div class="p-1" [innerHtml]="attribute.displayFunction(attribute.value)"></div>
      <!-- TODO: Remove function call from template -->
    </ng-container>
  </div>
</ng-template>

<!-- Layout for clustered layers -->
<ng-container *ngFor="let feature of layerDescriptor.features">
  <div *ngIf="isClustered(feature); else nonClusteredPopUp"
    style="font-size: small; line-height: 1; margin-bottom: 2px; border-bottom: 2px solid rgb(199, 199, 199)">
    <!-- TODO: Remove function call from template -->
    <div class="d-flex flex-column">
      <ng-container *ngTemplateOutlet="featureHeader;context:{feature: feature}"></ng-container>
      <div [hidden]="!(attributesForHover.length > 0)" class="ms-1 mt-1">
        <ng-container *ngFor="let attribute of attributesForHover">
          <div *ngIf="attribute.feature"
            [ngClass]="{'d-flex flex-column hs-hover-popup-feature' : hasMultipleSubFeatures(feature)}">
            <!-- TODO: Remove function call from template -->
            <ng-container
              *ngTemplateOutlet="featureHeader;context:{feature: attribute.feature, type: 'removeClusterPart'}">
            </ng-container>
            <ng-container *ngTemplateOutlet="featureAttribute;context:{attributes: attribute.attributes}">
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <!-- Layout for non-clustered layers -->
  <ng-template #nonClusteredPopUp>
    <div class="hs-hover-popup-feature">
      <ng-container *ngTemplateOutlet="featureHeader;context:{feature: feature, type: 'removeFeature'}">
      </ng-container>
      <ng-container
        *ngTemplateOutlet="featureAttribute;context:{attributes: data.service.serializeFeatureAttributes(feature)}"><!-- TODO: Remove function call from template -->
      </ng-container>
    </div>
  </ng-template>
</ng-container>